import { Icon, IconSet } from '@postscript/components';
import NonrepresentationalMediaPreview from 'components/messagePreview/components/NonrepresentationalMediaPreview';
import { useUser } from 'controllers/contexts/user';
import styled from 'styled-components';
import { convertShopNameToContactFileName } from 'utils/contactCards';

const StyledIcon = styled(Icon)`
  transform: rotate(-10deg);

  path {
    stroke: var(--flow-builder-dynamic-image-icon);
  }
`;

const StyledIconFill = styled(StyledIcon)`
  path {
    fill: var(--flow-builder-dynamic-image-icon);
    stroke: none;
  }
`;

interface ContactCardPreviewProps {
  showLink?: boolean;
}

const ContactCardPreview = ({
  showLink,
}: ContactCardPreviewProps): JSX.Element => {
  const {
    user: { shop_name: shopName },
  } = useUser();

  return (
    <NonrepresentationalMediaPreview
      description={convertShopNameToContactFileName(shopName)}
      icon={<StyledIconFill component={IconSet.ContactCard} />}
      link={showLink ? '/account/contact-card' : undefined}
      linkText="Edit"
      title="Contact Card"
    />
  );
};

export default ContactCardPreview;
